<template>
    <div class="row h-100 justify-content-center align-items-center">
        <div class="col-md-4">
            <div class="fs-3 fw-bold text-center mb-3">{{ title }}</div>
            <div class="d-flex flex-row flex-nowrap">
                <input
                    id="scan"
                    type="text"
                    v-model="form.uuid"
                    class="form-control"
                    :class="[form.errors.uuid ? 'is-invalid' : '']"
                    :placeholder="$t('customer.scan')"
                >
                <input
                    class="ms-1 btn btn-orange-custom text-white"
                    type="button"
                    @click.prevent="onSearch"
                    :value="$t('button.search')"
                />
            </div>
            <FormError v-if="form.errors.uuid" class="d-block">
                {{ form.errors.uuid }}
            </FormError>
        </div>
    </div>
</template>

<script setup lang="ts">
import {useForm} from "@inertiajs/vue3";
import FormError from "@/components/elements/FormError.vue";

const {uuid = null, uri} = defineProps<{
    uuid?: string,
    uri: string
    title: string
}>()

const form = useForm({
    uuid: uuid
})

const onSearch = () => {
    form.post(uri)
}
</script>

<style scoped>

</style>
